import { personalize } from '../../../../../common/services/personalize/service';

export const name = 'personalize';
export const defaultProp = null;
export const onParse = personalize;
